import { Divider } from '@mui/material'
import { CopyIcon, MobileIcon } from '@radix-ui/react-icons'
import React from 'react'

export default function FloatingIcons() {
  return (
    <div>
        <div className='fixed right-0 bg-prime-950 opacity-85 z-50 hover:opacity-100 transition-all duration-500 p-2 py-3 flex flex-col gap-2 justify-between rounded-s-md translate-y-60'>
            <div>
                <MobileIcon  className='size-9  text-gray-400 hover:text-white transition-all cursor-pointer'  />
            </div>
            <Divider className='bg-gray-500'/>

            <div>
                <CopyIcon  className='size-9 text-gray-400 hover:text-white transition-all cursor-pointer'  />
            </div>
            <Divider className='bg-gray-500'/>
            <div>
            <MobileIcon  className='size-9  text-gray-400 hover:text-white transition-all cursor-pointer'  />

            </div>
        </div>
    </div>
  )
}
